import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

const AccountingLayout = ({children}) => {
    const location = useLocation();
    const currentRoute = location.pathname;
    return (
        <div>
            <div className='h-[50px] w-full flex items-center'>
                <NavLink to="/admin/accounting/dashboard"  className={`font-medium text-sm nav-button px-3 py-3 ${currentRoute.includes('admin/accounting/dashboard') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Accounting Dashboard</NavLink>

                <NavLink to="/admin/accounting/college-accounts" className={`font-medium text-sm nav-button px-3 py-3 ${currentRoute.includes('admin/accounting/college-accounts') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>College Accounts</NavLink>

                <NavLink to="/admin/accounting/fees" className={`font-medium text-sm nav-button px-3 py-3 ${currentRoute.includes('admin/accounting/fees') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>College Fees</NavLink>
                
                <NavLink to="/admin/accounting/invoices" className={`font-medium text-sm nav-button px-3 py-3 ${currentRoute.includes('admin/accounting/invoices') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Invoices</NavLink>

                <NavLink to="/admin/accounting/payments" className={`font-medium text-sm nav-button px-3 py-3 ${currentRoute.includes('admin/accounting/payments') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Payments</NavLink>

                <NavLink to="/admin/accounting/sundry" className={`font-medium text-sm nav-button px-3 py-3 ${currentRoute.includes('admin/academics/sundry') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Sundry Accounts</NavLink>

                {/* <NavLink to="/admin/inventory/sundry" className={`font-medium text-sm nav-button px-3 py-3 ${currentRoute.includes('admin/academics/sundry') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Advance Payments</NavLink> */}


                
            </div>
            <div className={`mt-4 min-h-screen`}>
                <main>{children}</main>
            </div>
        </div>
    )
}

export default AccountingLayout